module.exports = __webpack_public_path__ + "img/dynamic-9.c32c7a3b.png";